import { domain } from "../../domain";

export {
    brand
}

function brand(per_page=null,page=null,id=null,name=null,orderBy=null){
    if(id){
        return `${domain}/get-brand?id=${id}`;
    } else if(name){
        return `${domain}/get-brand?per_page=${per_page}&page=${page}&name=${name}&orderBy=${orderBy}`
    } else {
        return `${domain}/get-brand?per_page=${per_page}&page=${page}&orderBy=${orderBy}`;
    }
}